import { render } from "./InitialD.vue?vue&type=template&id=6adb249e&scoped=true"
import script from "./InitialD.vue?vue&type=script&lang=js"
export * from "./InitialD.vue?vue&type=script&lang=js"

import "./InitialD.vue?vue&type=style&index=0&id=6adb249e&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6adb249e"]])

export default __exports__